import update from "immutability-helper";
import _ from "lodash/array";

const initialState = {
  lossReasons: [],
  lossReason: {},
  meta: {
    total_pages: 1,
    current_page: 1,
    total_count: 1
  },
  fetchParams: {
    status: null,
    search: null,
    page: 1,
    limit: 15
  },
  errors: false,
  isLoading: false,
  isModalVisible: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "FETCH_LOSS_REASONS_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "FETCH_LOSS_REASONS":
      return {
        ...state,
        lossReasons: action.response.data,
        meta: action.response.meta,
        isLoading: false
      };
    case "FETCH_LOSS_REASON_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "FETCH_LOSS_REASON":
      return {
        ...state,
        lossReason: action.response.data,
        isLoading: false,
        isModalVisible: true
      };
    case "PATCH_LOSS_REASON_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "PATCH_LOSS_REASON":
      return {
        ...state,
        lossReason: action.response.data,
        isLoading: false,
        isModalVisible: false
      };

    case "POST_LOSS_REASON_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "POST_LOSS_REASON":
      return {
        ...state,
        errors: false,
        lossReason: {},
        isLoading: false,
        isModalVisible: false
      };

    case "POST_LOSS_REASON_FAILURE":
      return {
        ...state,
        errors: true,
        isLoading: false
      };

    case "LOSS_REASON_ADD":
      return {
        ...state,
        lossReason: {
          name: null
        },
        errors: false,
        isLoading: false,
        isModalVisible: true
      };

    case "DELETE_LOSS_REASON_REQUEST":
      return {
        ...state,
        isLoading: true
      };

    case "DELETE_LOSS_REASON":
      return {
        ...state,
        isLoading: false
      };
    case "DELETE_LOSS_REASON_FAILURE":
      return {
        ...state,
        isLoading: false
      };
    case "REQUEST_LOSS_REASON_SEARCH":
      return update(state, {
        fetchParams: { search: { $set: action.value } }
      });

    case "REQUEST_LOSS_REASON_CHANGE_PAGE":
      return update(state, {
        fetchParams: { page: { $set: action.value } }
      });

    case "LOSS_REASON_TOGGLE_VISIBLE":
      return {
        ...state,
        isModalVisible: !state.isModalVisible
      };

    case "LOSS_REASON_CHANGE_NAME":
      return update(state, {
        lossReason: {
          name: { $set: action.value }
        }
      });

    default:
      return state;
  }
}
